import { render } from "./UISelect.vue?vue&type=template&id=baa5f8be"
import script from "./UISelect.vue?vue&type=script&lang=js"
export * from "./UISelect.vue?vue&type=script&lang=js"
script.render = render

export default script